import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { getFinanceBackMoneyById } from '@/api/financial-center'
import { menuBtn } from '@/utils/menu_level2_button'
import * as math from 'mathjs'

@Component({})
export default class BackMoneyParnterInfo extends Vue {
    logShow = true
    backMoneyId = NaN
    backMoneyInfo: any = ''
    status = ''
    isUpdatedData = '0'
    isShow = '0'
    activities = []
    fileList = []
    loading = false

    get orderAllPrice() {
        let num = 0
        this.backMoneyInfo.financeBackMoneyDetailList.forEach(item => {
                num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.price))))
            }
        )
        return num
    }

    get needBackMoney() {
        let num = 0
        this.backMoneyInfo.financeBackMoneyDetailList.forEach(item => {
            num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.needBackMoney))))
        })
        return num
    }

    get thisBackMoney() {
        let num = 0
        this.backMoneyInfo.financeBackMoneyDetailList.forEach(item => {
            num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.thisTimePrice))))
        })
        return num
    }

    get elImageUrls() {
        return this.backMoneyInfo.financeBackMoneyProofList.map(item => item.url)
    }

    created() {
        this.backMoneyId = Number(this.$route.query.id)
        this.getFinanceBackMoneyById()
        if(this.$route.query.status) this.status = this.$route.query.status as string
        if(this.$route.query.isShow) this.isShow = this.$route.query.isShow as string
        if(this.$route.query.isUpdatedData) this.isUpdatedData = this.$route.query.isUpdatedData as string
    }

    menuBtn = menuBtn

    formatDate = formatDate

    fileExtension(type) {
        return type.substring(type.lastIndexOf('.') + 1)
    }

    async getFinanceBackMoneyById() {
        this.loading = true
        await getFinanceBackMoneyById({ id: this.backMoneyId, isUpdatedData: this.isUpdatedData }).then((data: any)=>{
            this.backMoneyInfo = data.financeBackMoney
            //    审批流程
            this.activities =data.financeBackMoney.messageReviewList
            // 回款凭证
            this.fileList = data.financeBackMoney.financeBackMoneyProofList
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })

    }

    editBackMoney() {
        if(this.status === '审批中') {
            this.$message.error('审批中，不可编辑')
            return
        }
        this.$router.push({
            path: 'newBackMoneyMechanism',
            query: {
                backMoneyId: String(this.backMoneyId),
                status: this.status,
                isUpdatedData: this.isUpdatedData,
            }
        })
    }
    // 回款明细导出
    exportExcelData(res) {
        require.ensure([], () => {
            const { export_json_to_excel } = require('../../../../vender/Export2Excel.js')
            const tHeader = ['客户名称','订单编号','项目名称','开课时间','订单金额','订单已回款金额','订单待回款金额','本次回款金额']
            const filterVal =  ['customerName','code','souCourseName','souCourseSchoolBegin','price','backMoney','needBackMoney','thisTimePrice']
            const list = this.backMoneyInfo.financeBackMoneyDetailList
            const data = this.formatJson(filterVal, list)
            export_json_to_excel(tHeader, data, '回款明细')
        })
    }
    formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
    }
}
